import { createSlice } from '@reduxjs/toolkit';

import { loadItemCarousels } from './itemCarousel.actions';
import { defaultItemCarouselState } from './itemCarousel.types';

const itemCarouselSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadItemCarousels.pending, (state, { meta }) => {
            delete state.errored[meta.arg.itemId];
            state.loading = true;
        });

        builder.addCase(loadItemCarousels.fulfilled, (state, { payload }) => {
            state.byId[payload.itemId] = payload.carousels.map(({ items, title, viewMoreUrl }) => ({
                itemIds: items.map((item) => item.itemId),
                title,
                viewMoreUrl,
            }));
            delete state.errored[payload.itemId];
            state.loaded[payload.itemId] = Date.now();
            state.loading = false;
        });

        builder.addCase(loadItemCarousels.rejected, (state, { meta }) => {
            // A failed fetch must be distinguishable from an in-flight one — otherwise the
            // consumer reads "not loaded" as "still loading" and shows the skeleton forever.
            // `loaded` stays unset so navigation/remount still retries.
            state.errored[meta.arg.itemId] = true;
            state.loading = false;
        });
    },
    initialState: defaultItemCarouselState,
    name: 'itemCarousel',
    reducers: {},
});

export const { reducer: itemCarouselReducer } = itemCarouselSlice;
